import { Link, useNavigate } from "react-router-dom";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { TrafficLightBadge } from "components/atoms/Badge";
import { InfoColumn, InfoColumnValue, InfoRow } from "components/atoms/InfoRow";
import Error from "components/molecules/Error";
import Loading from "components/molecules/Loading";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { useVilDuViteMerListPageQuery } from "pages/Content/VilDuViteMer/VilDuViteMer.graphql-gen";

export default function VilDuViteMerListPage() {
	const navigate = useNavigate();
	const { data, error, loading } = useVilDuViteMerListPageQuery();

	return (
		<>
			<MainLayoutPageHeader
				title={
					<Flex gap="var(--grid-2)">
						Vil du vite mer
						<Link to="create" title="Ny vil du vite mer-artikkel">
							<FontAwesomeIcon icon={faPlusCircle} />
						</Link>
					</Flex>
				}
			/>
			<Flex style={{ marginTop: "40px", borderRadius: "15px", overflow: "hidden" }} direction={Direction.column}>
				{error && !loading && <Error errorMessage="Feil ved henting av data" />}
				{loading && !data && <Loading />}
				{data?.paginateHelpPages?.items?.slice().map((content) => (
					<InfoRow
						key={content.id}
						interactive
						onClick={() => {
							navigate("/vil-du-vite-mer/" + content.id);
						}}
					>
						<InfoColumn width="10em">
							<InfoColumnValue>
								<TrafficLightBadge green={content?.published} red={!content?.published}>
									<>{content?.published ? "Publisert" : "Ikke publisert"}</>
								</TrafficLightBadge>
							</InfoColumnValue>
						</InfoColumn>
						<InfoColumn>
							<InfoColumnValue>{content?.title}</InfoColumnValue>
						</InfoColumn>
					</InfoRow>
				))}
			</Flex>
		</>
	);
}
